import { Component, OnInit } from '@angular/core';
import { SummaryBase } from '../../summary-base';
import { Router } from '@angular/router';
import { InstanceService } from 'src/app/service/instance.service';
import { ProcessService } from 'src/app/service/process.service';
import { AttributeService } from '../../dynamic/service/attribute.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { SecurityService } from 'src/app/service/security.service';
import { AuthenticationService } from 'src/app/service/auth.service';
import { MaskApplierService } from 'ngx-mask';
import { CurrencyService } from 'src/app/service/currency.service';

@Component({
  selector: 'app-dash-summary',
  templateUrl: './dash-summary.component.html',
  styleUrls: ['./dash-summary.component.scss']
})
export class DashSummaryComponent extends SummaryBase implements OnInit {

  constructor(
    attrService: AttributeService,
    processService: ProcessService,
    instanceService: InstanceService,
    router: Router,
    spinner: NgxSpinnerService,
    securityService: SecurityService,
    authService: AuthenticationService,
    maskService: MaskApplierService,
    currencyService: CurrencyService) {
      super(attrService, processService, instanceService, router, spinner, securityService, authService, maskService, currencyService)
    }

  ngOnInit() {
  }

}
